import React from "react";
import './NoBoardSelected.css';

const NoBoardSelected = () => {
    return (
       <div className="noBoardSelected">
            <h2>Select Board to View from Menu</h2>
       </div>
    )
}

export default NoBoardSelected;